<template>
  <b-container>
    <b-row class="p-3">
      <h5>عنوان منو: </h5><h5>{{ menu.name }}</h5>
    </b-row>

    <b-row class="p-3">
      <b-button pill v-b-modal.editMenu @click="fillEditMenuObj">ویرایش ویژگی های منو</b-button>
    </b-row>

    <b-modal id="editMenu" ref="editMenu" centered scrollable hide-header-close
             title="ویرایش منو" header-bg-variant="dark"
             header-text-variant="light" @ok="onSubmit">

      <form @submit.stop.prevent="onSubmit">

        <form-group :validations="$v.editMenu.name">
          <div slot-scope="{ errors, invalid }">
            <b-form-input type="text" v-model="editMenu.name" placeholder="عنوان منو"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group :validations="$v.editMenu.background">
          <div slot-scope="{ errors, invalid }">
            <b-form-input type="color" v-model="editMenu.background"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </form>

      <template #modal-footer="{ ok, cancel}">
        <b-row class="d-flex flex-row justify-content-around w-100">
          <b-button size="md" variant="success" @click="ok()">ویرایش</b-button>
          <b-button size="md" variant="danger" @click="cancel()">انصراف</b-button>
        </b-row>
      </template>
    </b-modal>

    <b-row>

      <b-col cols="12">
        <b-card class="item-container shadow">
          <b-row class="d-flex flex-row justify-content-center align-items-center p-2">
            <h6> آیتم ها</h6>
          </b-row>
          <h6 class="text-center w-100 p-3" v-if="!menu.children || menu.children.length===0">!! هیچ آیتمی برای این منو
            تعریف نشده است !!</h6>
          <MenuItem v-for="item in menu.children" :key="item.id" :item="item" v-else/>

        </b-card>
      </b-col>

    </b-row>

    <b-row class="add-item-btn-container">
      <b-button class="add-item-btn p-2 rounded-circle bg-info" v-b-modal.modal>
        <b-icon icon="plus" class="m-0 p-0 text-dark"/>
      </b-button>
    </b-row>

    <NewItemModalForm/>

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import MenuItem from "../../components/dashboard/menu/MenuItem";
import NewItemModalForm from "../../components/dashboard/menu/NewItemModalForm";
import FormGroup from "../../components/validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../components/validator/FormErrorsManager.vue'

export default {
  name: "Menu",
  components: {MenuItem, NewItemModalForm, FormGroup, FormErrorsManager},
  data() {
    return {
      menuPositions: [
        {text: 'منو اصلی فروشگاه', value: 'store_nav'},
        {text: 'منو فوتر سایت', value: 'store_footer'},
        {text: 'منو اصلی وبلاگ', value: 'blog_nav'},
        {text: 'منو فوتر وبلاگ', value: 'blog_footer'}],

      menuID: this.$route.params.id,
      editMenu: {}
    };
  },
  validations: {
    editMenu: {
      name: {required},
      background: {required},
    }
  },
  computed: {
    ...mapGetters({
      menu: "Menu/getMenu",
      items: "Menu/getMenuItems"
    }),
  },
  methods: {
    updateMenuFeature() {
      this.$store.dispatch("Menu/updateMenu", this.editMenu)
    },
    fillEditMenuObj() {
      this.editMenu = this.menu
      this.editMenu.menu_id = this.menu.id
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent){
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.updateMenuFeature()
        this.$nextTick(() => {
          this.$bvModal.hide('editMenu')
        })
      }
    }
  },
  mounted() {
    this.$store.dispatch("Menu/getMenu", this.menuID)
  }

}
</script>

<style scoped>
.add-item-btn {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 30px;
}

.item-container {
  border-radius: 20px;
}

.add-item-btn-container {
  position: absolute;
  width: max-content;
  right: 30px;
  bottom: 30px;
}
</style>